import { signalStore, withComputed, withState } from '@ngrx/signals';
import { initialState, State, withAuthReducer } from './with-auth.reducer';
import { withAuthEffects } from './with-auth.effect';
import { computed } from '@angular/core';
import { UserTypeEnum } from '../../enums/auth';

export const AuthStore = signalStore(
  { providedIn: 'root' },
  withState<State>(initialState),
  withComputed(({ 'custom:user_type': userType }) => ({
    userType: computed(() => userType()),
    isCarrierAdmin: computed(() => {
      return userType() === UserTypeEnum.CARRIER_ADMIN;
    }),
  })),
  withAuthReducer(),
  withAuthEffects(),
);
